module.exports = __webpack_public_path__ + "static/media/COS_LOGO.b8403457.png";